import React from 'react';

import moneyIcon from './../../../../../../statics/img/money-bills-simple.svg';

function CancelModal({ onCancel, onClose, isLoading }) {
  return (
    <div className="instapay_modal">
      <div className="instapay_modal_header">
        <div className="instapay_modal_header_icon">
          <img src={moneyIcon} alt="money" />
        </div>
        <div className="instapay_modal_header_text">
          <p className="instapay_modal_header_title">Cancel payment</p>
          <p className="instapay_modal_header_support-text">
            Are you sure you want to cancel this payment?
          </p>
        </div>
      </div>
      <div className="instapay_modal_footer">
        <button
          onClick={onCancel}
          disabled={isLoading}
          className="instapay_btn instapay_btn_secondary-error"
        >
          Yes, cancel it
        </button>
        <button
          onClick={onClose}
          disabled={isLoading}
          className="instapay_btn instapay_btn_main"
        >
          No, go back
        </button>
      </div>
    </div>
  );
}

export default CancelModal;
